module.exports = __webpack_public_path__ + "media/newstyle/images/icon-chevron_right-3897d884edee4a977814bc7620e16e2b.svg";